module.exports = __webpack_public_path__ + "img/advantage8.8bc95c69.png";